/**
 * Business logic per Cross Company Target Workers autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import crossCompanyMirrorConfigsService from '../services/crossCompanyMirrorConfigsService';
import type { AutocompleteResult, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export interface CrossCompanyTargetWorkersOptions {
	targetCompany: string;
	searchString?: string;
	id?: number | string | null;
	notInIds?: Array<number | string> | null;
}

export async function getCrossCompanyTargetWorkersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: CrossCompanyTargetWorkersOptions,
): Promise<AutocompleteResult[]> {
	const { targetCompany, searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,code,name',
		expand: {
			user: {
				select: 'userName,enabled',
			},
		},
		top: 20,
		orderBy: ['user/enabled desc', 'name'],
		filter: {
			and: [],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			'tolower(name)': { contains: searchString },
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [
				{
					id: {
						in: notInIds,
					},
				},
			],
		});
	}

	const result = await crossCompanyMirrorConfigsService.getCrossCompanyWorkers(
		targetCompany,
		buildQuery(context),
	);
	return result;
}
